module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-370.32b0af7.woff2";